import SyncSave from './src/sync-save';

export default SyncSave;
